export const treeObj = (obj) => {
  const val = obj.map((el, i) => {
    let main = {
      key: i.toString(),
      label: el.name,
      value: `${el.id}~${el.name}`,
      data: `${el.name} Folder`,
      domainId: el.domainId,
      vendorId: el.vendorId,
      id: el.id,
      children: [],
    };
    if (el.childNodes && el.childNodes.length > 0) {
      el.childNodes.map((elx, ind) => {
        let child = {
          key: `${i}-${ind}`,
          label: elx.name,
          data: elx.id,
          value: `${elx.id}~${elx.name}`,
          domainId: elx.domainId,
          vendorId: elx.vendorId,
          id: elx.id,
          children: [],
        };
        main.children.push(child);
        if (elx.childNodes && elx.childNodes.length > 0) {
          elx.childNodes.map((ex, idx) => {
            let childOne = {
              key: `${i}-${ind}-${idx}`,
              label: ex.name,
              value: `${ex.id}~${ex.name}`,
              data: ex.id,
              domainId: ex.domainId,
              vendorId: ex.vendorId,
              id: ex.id,
              children: [],
            };
            child.children.push(childOne);
            if (ex.childNodes && ex.childNodes.length > 0) {
              ex.childNodes.map((x, ix) => {
                let Two = {
                  key: `${i}-${ind}-${idx}-${ix}`,
                  label: x.name,
                  value: `${x.id}~${x.name}`,
                  data: x.id,
                  domainId: x.domainId,
                  vendorId: x.vendorId,
                  id: x.id,
                  children: [],
                };
                childOne.children.push(Two);
                if (x.childNodes && x.childNodes.length > 0) {
                  x.childNodes.map((val, ii) => {
                    let Three = {
                      key: `${i}-${ind}-${idx}-${ix}-${ii}`,
                      label: val.name,
                      data: val.id,
                      value: `${val.id}~${val.name}`,
                      domainId: val.domainId,
                      vendorId: val.vendorId,
                      id: val.id,
                      children: [],
                    };
                    Two.children.push(Three);
                    if (val.childNodes && val.childNodes.length > 0) {
                      val.childNodes.map((vl, iix) => {
                        let four = {
                          key: `${i}-${ind}-${idx}-${ix}-${ii}-${iix}`,
                          label: vl.name,
                          data: vl.id,
                          value: `${vl.id}~${vl.name}`,
                          domainId: vl.domainId,
                          vendorId: vl.vendorId,
                          id: vl.id,
                          children: [],
                        };
                        Three.children.push(four);
                        if (vl.childNodes && vl.childNodes.length > 0) {
                          vl.childNodes.map((vlx, ixx) => {
                            let five = {
                              key: `${i}-${ind}-${idx}-${ix}-${ii}-${iix}-${ixx}`,
                              label: vlx.name,
                              data: vlx.id,
                              value: `${vlx.id}~${vlx.name}`,
                              domainId: vlx.domainId,
                              vendorId: vlx.vendorId,
                              id: vlx.id,
                              children: [],
                            };
                            four.children.push(five);
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
    return main;
  });
  return val;
};
export const treeCheckedObj = (orgObject, selectedKeys) => {
  const temp = [];
  const orgs = orgObject[0].children;

  for (const [key, value] of Object.entries(selectedKeys)) {
    orgs.map((el) => {
      if (el.Value === value) {
        let o = {
          Key: parseInt(el.id),
          Value: el.label,
        };
        temp.push(o);
      }
      if (el.children && el.children.length > 0) {
        el.children.map((elx, ind) => {
          if (el.Value === value) {
            let o = {
              Key: parseInt(elx.id),
              Value: elx.label,
            };
            temp.push(o);
          }
          if (elx.children && elx.children.length > 0) {
            elx.children.map((ex, idx) => {
              if (ex.Value === value) {
                let o = {
                  Key: parseInt(ex.id),
                  Value: ex.label,
                };
                temp.push(o);
              }
              if (ex.children && ex.children.length > 0) {
                ex.children.map((x, ix) => {
                  if (x.Value === value) {
                    let o = {
                      Key: parseInt(x.id),
                      Value: x.label,
                    };
                    temp.push(o);
                  }
                  if (x.children && x.children.length > 0) {
                    x.children.map((val, ii) => {
                      if (ii.Value === value) {
                        let o = {
                          Key: parseInt(val.id),
                          Value: val.label,
                        };
                        temp.push(o);
                      }
                      if (val.children && val.children.length > 0) {
                        val.children.map((vals, ix) => {
                          if (ix.Value === value) {
                            let o = {
                              Key: parseInt(vals.id),
                              Value: vals.label,
                            };
                            temp.push(o);
                          }
                          if (vals.children && vals.children.length > 0) {
                            vals.children.map((valss, ixx) => {
                              if (ixx.Value === value) {
                                let os = {
                                  Key: parseInt(valss.id),
                                  Value: valss.label,
                                };
                                temp.push(os);
                              }
                            });
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    });
  }

  return temp;
};
